// This is a mixin which provides an object with the ability to manage ComponentEvents.
// Pass in obj to extend the obj's prototype with the methods.

export function MixinEvents(obj, eventsInstance) {
    obj.events = (typeof eventsInstance === 'undefined' ? {} : eventsInstance);
    mixinMethods(obj);
}

function mixinMethods(obj) {
    Object.assign(obj.__proto__, {

        handleEvent(name, handler) {
            if (this.events.hasOwnProperty(name)) {
                this.events[name].push(handler);
            } else {
                this.events[name] = [handler];
            }
        },

        // This is a bit tricky, because how would you identify functions?
        // This simple solution should work if you pass THE SAME handler!
        unhandleEvent(name, handler) {
            if (!this.events.hasOwnProperty(name)) { return }
            let index = this.events[name].indexOf(handler);
            if (index != -1) { this.events[name].splice(index, 1) }
        },

        fireEvent (componentEvent, memo) {
            const name = (componentEvent.hasOwnProperty('type') ? componentEvent.type : '');
            if (!this.events.hasOwnProperty(name)){ return }
            if (!memo) { memo = {} }
            componentEvent.memo = memo;
            this.events[name].forEach((ev)=>{ ev.apply(null, [componentEvent]) });
        }

    });
}
